//#region ../../../shared/common/src/errors/contextual-error.ts
var e = class extends Error {
	context;
	constructor(e, t = {}) {
		super(e), this.name = "ContextualError", this.context = t;
	}
}, t = (e) => {
	window.RevolugoElements = {
		...window.RevolugoElements,
		ready: (e) => {
			let t = window.RevolugoElements?._ready;
			window.RevolugoElements._ready = () => {
				t && t(), e();
			};
		}
	};
	let t = document.createElement("script");
	t.src = e, t.type = "module", t.async = !1;
	let [n] = document.querySelectorAll("script");
	return n ? n?.parentNode?.insertBefore(t, n) : document.head.append(t), t;
}, n = (n, r) => {
	let i = n ? "ELEMENTS_NEXT_ENTRY_URL" : "ELEMENTS_ENTRY_URL", a = process.env[i];
	if (!a) throw new e("Missing elements entry URL env var", { envVar: i });
	let o = r || "7.20.0", s = o ? a.replace("7.20.0", o) : a, c = [...document.querySelectorAll("script")].find((e) => e.src.includes(s));
	return new Promise((e) => {
		if (c) {
			e(!0);
			return;
		}
		t(s).addEventListener("load", () => {
			e(!0);
		});
	});
};
//#endregion
export { t as injectScript, n as loadScript };

//# sourceMappingURL=index.script.js.map